module.exports = __webpack_public_path__ + "static/media/evening-icon.68c9f496.svg";